/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['em[_ngcontent-%COMP%]{float:right;color:#e05c65;padding-left:10px}.link-color[_ngcontent-%COMP%]{color:#0082c8}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY2xtdGxrL25ldy1tZXNzYWdlL21lc3NhZ2UtZm9ybS9tZXNzYWdlLWZvcm0uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvc3JjL2FwcC9jbG10bGsvbmV3LW1lc3NhZ2UvbWVzc2FnZS1mb3JtL21lc3NhZ2UtZm9ybS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/clmtlk/new-message/message-form/message-form.component.scss.shim.ngstyle.ts